import React from 'react';
import { useIntl } from 'react-intl';

import { NavigationButton } from 'app/shared/components/molecules';
import { useEventPageContext } from 'app/fan/context/EventPage';

export const EnterCompetitionButton = () => {
  const { formatMessage } = useIntl();
  const { event, eventAttendee, isPlusOneFlow } = useEventPageContext();

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect this to be present
  if (!event || !event.competition) {
    return null;
  }

  const hasEntered = eventAttendee?.currentState === 'applied';
  const competitionUid = event.competition.uid;

  const disabled = hasEntered || !competitionUid || !isPlusOneFlow;

  return (
    <NavigationButton
      fullWidth
      variant="primary"
      href={disabled ? undefined : `/comp/${competitionUid}`}
      data-qaid="event-page-enter-competition-button"
      disabled={disabled}
      aria-disabled={disabled}
      px={3}
    >
      {formatMessage({ id: 'event.competitionFlow.enter' })}
    </NavigationButton>
  );
};
